import $ from 'jquery';

$.fn.extend({
  loadCatalogPromotionActionConfiguration(target) {
    const targetElement = target;
    if (
      targetElement == null ||
      targetElement.querySelector('#sylius_catalog_promotion_actions select[name*="type"]') == null
    ) {
      return;
    }

    targetElement.querySelector('#sylius_catalog_promotion_actions select[name*="type"]').onchange = function () {
      const parent = this.parentElement.parentElement;
      const newConfig = document.createElement('div');
      newConfig.innerHTML = this.selectedOptions[0].getAttribute('data-configuration');
      const oldConfig = parent.nextElementSibling;

      parent.parentElement.replaceChild(newConfig, oldConfig);

      const oldConfigInputName = oldConfig.querySelector('input').getAttribute('name');
      const newConfigInputs = newConfig.querySelectorAll('input');

      newConfigInputs.forEach(element => {
        let newConfigInputName = element.getAttribute('name');

        newConfigInputName = oldConfigInputName.replace(
          oldConfigInputName.substring(oldConfigInputName.indexOf('[configuration]') + 15),
          newConfigInputName.substring(newConfigInputName.indexOf('configuration') + 13),
        );

        $(element).attr('name', newConfigInputName);
      });
    };
  },
});
